import React, {Component} from 'react';
import firebase from 'firebase/app';
import 'firebase/database';
import {ImageUploader} from '../uploaders';
import RichTextArea from '../rich-text-area/rich-text-area';
import './booth-editor.css';

/** @class ImageContentData
 * A component to enable editing properties
 * specific to ImageContents.
 */
export default class ImageContentData extends Component {
  /** @constructor
    * Creates a new instance of the component
    */
  constructor(props) {
    super(props);
    this.state = props.content;
    this.handleChange = this.handleChange.bind(this);
    this.handleTextChange = this.handleTextChange.bind(this);
    this.handleImageUpload = this.handleImageUpload.bind(this);
    this.handleBlur = this.handleBlur.bind(this);
  }
  /** @function handleChange
    * Applies user changes to the state
    * @param {InputEvent} event - the triggering event
    */
  handleChange(event) {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;
    this.setState({
      [name]: value
    });
  }
  handleTextChange(html) {
    this.setState({caption: html}, () => this.handleBlur());
  }
  /** @function handleImageUpload
    * Applies user changes to the state
    * @param {url} url - the URL of the image
    */
  handleImageUpload(url) {
    this.setState({image: url}, () => this.handleBlur());
  }
  /** @function handleBlur
    * Applies the current state to the database
    */
  handleBlur() {
    firebase.database().ref(this.props.dataURL).set(this.state);
  }
  /** @function render
    * Renders the component
    */
  render(){
    return (
      <div className="dialog-content">
        <h3 className="header">Image Content</h3>
        <div className="input-group">
          <label htmlFor="name">Name</label><br/>
          <input type="text"
            name="name"
            value={this.state.name}
            onChange={this.handleChange}
            onBlur={this.handleBlur}
            />
        </div>
        <div className="input-group">
          <label htmlFor="columns">Columns</label><br/>
          <input type="number"
            name="columns"
            value={this.state.columns}
            onChange={this.handleChange}
            onBlur={this.handleBlur}
            max="4"
            min="1"
            step="1"
            />
        </div>
        <div className="input-group">
          <label htmlFor="published">
            <input type="checkbox"
              name="published"
              checked={this.state.published}
              onChange={this.handleChange}
              onBlur={this.handleBlur}
              />&nbsp;
            Published
          </label>
        </div>
        <div className="input-group">
          <ImageUploader
            name="Image"
            value={this.state.image}
            dataURL={this.props.dataURL}
            onUpload={this.handleImageUpload}
            />
        </div>
        <div className="input-group">
          <label>Caption</label>
          <RichTextArea value={this.state.caption}
            onChange={this.handleTextChange}/>
        </div>
        <div className="input-group">
          <label htmlFor="name">URL (optional)</label><br/>
          <input type="url"
            name="url"
            value={this.state.url}
            onChange={this.handleChange}
            onBlur={this.handleBlur}
            />
          <p className="hint">
            A URL to visit when the image is clicked
          </p>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/booth-editor/image-content-data.js